<nav [class]="'bg-white sticky top-0 shadow-1 ' + (rounded ? 'border-round-3xl m-2' : '' )" [tabPanel]="tabPanel"
     mat-tab-nav-bar>
  <div class="flex flex-column justify-items-center align-items-center justify-content-center">
    <button (click)="toggleMenu ? toggleMenu() : undefined" aria-label="Menu icon" color="primary" mat-icon-button>
      <mat-icon class="material-symbols-outlined">menu</mat-icon>
    </button>
  </div>
  <div class="flex flex-column justify-items-center align-items-center justify-content-center">
    <img *ngIf="showLogo && logo" src="/assets/images/logo.png" alt="image" class="h-2rem opacity-70">
    <div *ngIf="title" class="flex align-items-center gap-2">
      <span class="text-xs font-semibold uppercase px-2 text-gray-700">{{ title }}</span>
    </div>
  </div>

  <ng-content select="[leftSide]"></ng-content>
  <div
    #rla="routerLinkActive"
    *ngFor="let link of navLinks"
    [active]="rla.isActive"
    [routerLink]="link.link" mat-align-tabs="start"
    mat-stretch-tabs="false"
    mat-tab-link routerLinkActive
  >
    <div class="flex flex-column justify-items-center align-items-center">
      <mat-icon *ngIf="withIcon" class="example-tab-icon material-symbols-outlined">{{link.icon}}</mat-icon>
      <span class="text-sm">{{link.label}}</span>
    </div>
  </div>
  <ng-content select="[rightSide]"></ng-content>
  <div class="flex align-items-center px-2">
    <app-setting-button></app-setting-button>
    <app-user-avatar></app-user-avatar>
  </div>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
